import loadable from "@loadable/component";
import StatusIcon from "../../../Icons/StatusIcon";

const ServiceTypeListComponent = loadable(
  () => import("../../../components/Settings/ServiceType/ServiceTypeList")
);

const ServiceTypeList = () => {
  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <StatusIcon />
        <span className="text-[#5E5757] font-bold text-xl">Service Type</span>
      </div>
      <ServiceTypeListComponent />
    </>
  );
};



export default ServiceTypeList
